<template>
  <div
    class="brand-body relative z-10 mx-auto mb-8 max-w-3xl overflow-hidden bg-white shadow-lg sm:mb-10"
    :class="club.CustomCSSClass"
  >
    <div class="bg-white">
      <div>
        <img
          :src="club.BannerUrl"
          class="w-full object-cover pb-2"
          style="height: 130px"
        >
      </div>

      <div
        class="brand-heading ml-3 inline w-auto border-b-2 border-brand-800 p-2 pt-0 text-xl tracking-wide sm:ml-5 sm:text-2xl"
      >
        {{ club.Name }}
      </div>

      <div class="brand-body p-3 pt-4 text-sm xs:text-base sm:p-5">
        {{ club.ShortDescription }}
      </div>
    </div>

    <!-- <div
      style="background-color: #f6f6f6"
    >
      <div class="flex justify-center p-2 xs:p-5">
        <div class="text-center pl-3 pr-3">
          <div class="text-lg sm:text-2xl font-bold text-brand-500">
            {{ club.Location.Distance * 0.00018939 | round(1) }}
          </div>
          <div class="text-sm sm:text-base">
            miles away
          </div>
        </div>

        <div class="text-center pl-3 pr-3">
          <div class="text-lg sm:text-2xl font-bold text-brand-500">
            {{ club.Prices.AvgPrice | round(1) }}
          </div>
          <div class="text-sm sm:text-base">
            average price
          </div>
        </div>

        <div class="text-center pl-3 pr-3">
          <div class="text-lg sm:text-2xl font-bold text-brand-500">
            {{ club.Prices.MinPrice }}-{{ club.Prices.MaxPrice }}
          </div>
          <div class="text-sm sm:text-base">
            price range
          </div>
        </div>

        <ChevronLinkButton
          :to="to"
          :use-brand="true"
          value="Select"
          class="hidden xs:inline-block mt-3 pl-10"
        />
      </div>

      <div class="xs:hidden bg-brand-500 text-white text-center p-2">
        Select
      </div>
    </div>
     -->

    <router-link :to="`/booking/clubs/${club.Id}`">
      <PrimaryButton
        :text="'View tee times'"
        :full-width="true"
      />
    </router-link>
  </div>
</template>

<script>
import PrimaryButton from '../base/button/primaryButton.vue';

export default {
  components: {
    PrimaryButton,
  },
  filters: {
    round(value, decimals) {
      let decimalValue = 0;
      let targetValue = 0;

      if (value > 0) {
        targetValue = value;
      }

      if (decimals > 0) {
        decimalValue = decimals;
      }

      /*eslint-disable */
      return Math.round(targetValue * Math.pow(10, decimalValue)) / Math.pow(10, decimalValue);
    },
  },
  props: {
    club: {
      type: Object,
      default: null,
    },
    to: {
      type: String,
      default: '',
    },
  },  
};
</script>
